import { showInput } from './showInput';
import { postInsertComment, getCommentById, getCommentList, getCommentChildren } from '../services';
import { message as toast } from '@src/mobile/components/ModalBox';

export const replyComment = ({
    replyName = '',
    subjectId,
    rootId = '0',
    pId = '0',
    docMeta = {},
    callback,
}) => {
    showInput({
        replyName,
        callback: async comment => {
            try {
                const { docUrl, docName, skey } = docMeta;
                const res = await postInsertComment({
                    comment,
                    docUrl: docUrl || (subjectId ? `ucms_${subjectId}` : ''),
                    docName: docName || '',
                    skey: skey || '',
                    quoteId: pId,
                });

                // jsonp 直接返回业务数据；兼容 axios 形态
                const result = res?.data && res.status !== undefined ? res.data : res;

                if (result) {
                    const { code, message } = result;

                    // 大评论系统成功码为 1；兼容旧接口 200
                    if (code === 1) {
                        toast({ content: '评论已发送' });
                        // 新接口不返回评论 id，无法即时插入列表
                        return;
                    }

                    if (code === 200 && message) {
                        toast({ content: '评论已发送' });
                        const detailRes = await getCommentById({ commentId: message, subjectId });

                        if (detailRes && detailRes.status === 200 && detailRes.data) {
                            const { code: detailCode, data } = detailRes.data;

                            if (detailCode === 200 && data) {
                                callback?.(data);
                            }
                        }
                    } else {
                        toast({ content: result.message || '评论发送失败' });
                    }
                }
            } catch (e) {
                console.error(e);
                toast({ content: '评论发送失败' });
            }
        },
    });
};

// 处理评论列表每一项之间的回复关系
export const addReplyUser = (comments = []) => {
    if (Array.isArray(comments) && comments.length) {
        comments.forEach(comment => {
            if (comment?.pid !== comment?.rootId) {
                const target = comments.find(item => item?.id === comment?.pid);

                if (target) {
                    comment.replyUser = target.commentUserName;
                }
            }
        });
    }
};

export const getList = async ({ subjectId, page, pageSize, sort, rootId, docUrl }) => {
    try {
        const finalDocUrl = docUrl || (subjectId ? `ucms_${subjectId}` : '');
        const isChildren = rootId && rootId !== '0';
        const res = isChildren
            ? await getCommentChildren({
                  docUrl: finalDocUrl,
                  commentId: rootId,
                  subjectId,
                  page,
                  pageSize: pageSize || 20,
                  order: sort?.type || 'asc',
              })
            : await getCommentList({
                  subjectId,
                  page,
                  pageSize,
                  sort,
                  docUrl: finalDocUrl,
              });

        if (res && res.status === 200 && res.data) {
            const { code, data } = res.data;

            if (code === 200 && data) {
                const { pagination, list } = data;
                const { current, pageSize, total } = pagination;

                // 处理评论回复者之间的关系
                if (!isChildren) {
                    list.forEach(item => {
                        addReplyUser(item.comments);
                    });
                } else {
                    addReplyUser(list);
                }

                return { list, current, pageSize, total };
            }
        }
    } catch (e) {
        console.error(e);
    }

    return {};
};
